'use client';

import Accordion from '@enlighten/design-system/dist/Accordion';
import AccordionDetails from '@enlighten/design-system/dist/AccordionDetails';
import AccordionSummary from '@enlighten/design-system/dist/AccordionSummary';
import Grid from '@enlighten/design-system/dist/Grid';
import Typography from '@enlighten/design-system/dist/Typography';
import Link from 'next/link';
import { useState } from 'react';

import Arrow from '@/assets/images/pages/bizking/arrow_b_gray.svg';

const list = [
	{
		summary: '발전왕 비즈를 사용할 때 비용을 내야하나요?',
		details: '아니요. 발전왕 비즈는 별도의 비용 없이 무료로 사용하실 수 있습니다.',
	},
	{
		summary: '발전왕 비즈를 신청하기 위해서는 어떤 절차를 거쳐야 하나요?',
		details: (
			<Grid
				sx={{
					lineHeight: 1.5,
					a: {
						color: 'primary.main',
					},
				}}
			>
				{'발전왕 비즈 서비스페이지('}
				<Link href="https://bizking.enlighten.kr" target="_blank">
					bizking.enlighten.kr
				</Link>
				{')에 접속해 ‘회원가입’ 버튼을 눌러 회원가입 절차를 진행해주세요.'}
			</Grid>
		),
	},
	{
		summary: '발전왕 모니터링(RTU)이 무엇인가요?',
		details: (
			<>
				{`발전왕 모니터링(RTU)은 실시간으로 발전상황을 모니터링 할 수 있도록 발전소의 데이터를 수집하는 데이터 취득장치입니다.
수집된 발전량 데이터는 발전왕 및 발전왕 비즈를 통해 확인할 수 있습니다.
담당자에게 문의해주시면 자세하게 안내드리겠습니다!\n`}
				<Link href="mailto:rtu@enlighten.kr">rtu@enlighten.kr</Link>&nbsp;&nbsp;<Link href="tel:02-6231-0145">{'☎︎ 02-6231-0145'}</Link>
			</>
		),
	},
];

export default function Section7() {
	const [accordionIndex, setAccordionIndex] = useState<0 | 1 | 2>();

	return (
		<Grid container justifyContent="center" width="100%">
			<Grid container direction="column" width="100%" maxWidth={1440} padding={{ xs: '60px 24px', md: '100px 16px 140px' }}>
				<Typography fontSize={{ xs: 24, md: 40 }} fontWeight={700} color="common.black" marginBottom={5}>
					자주 묻는 질문
				</Typography>
				<Grid container direction="column" borderTop={(theme) => `1px solid ${theme.palette.grey['300']}`}>
					{list.map(({ summary, details }, i) => (
						<Accordion
							key={i}
							expanded={accordionIndex === i}
							onChange={() => {
								setAccordionIndex((index) => {
									if (index == null || index !== i) {
										return i as 0 | 1 | 2;
									}

									return undefined;
								});
							}}
							sx={(theme) => ({
								borderBottom: `1px solid ${theme.palette.grey['300']}`,
								borderRadius: 0,
								boxShadow: 'none',
								transition: 'background-color 0.3s ease',
								'&.Mui-expanded': {
									bgcolor: 'grey.100',
									margin: 0,
								},
							})}
						>
							<AccordionSummary
								expandIcon={<Arrow width={24} height={48} />}
								sx={{
									fontSize: { xs: 15, md: 20 },
									lineHeight: 1.5,
									letterSpacing: '-.05em',
									color: 'common.black',
									height: 88,
									padding: { xs: '20px 5px', md: '20px 50px' },
									svg: {
										transform: 'rotate(180deg)',
									},
									'&.Mui-expanded': {
										fontWeight: 700,
									},
								}}
							>
								{summary}
							</AccordionSummary>
							<AccordionDetails
								sx={{
									fontSize: { xs: 16, md: 18 },
									lineHeight: 1.5,
									letterSpacing: '-.05em',
									whiteSpace: 'pre-line',
									marginBottom: '1em',
									padding: { xs: '20px 5px', md: '20px 50px' },
								}}
							>
								{details}
							</AccordionDetails>
						</Accordion>
					))}
				</Grid>
			</Grid>
		</Grid>
	);
}
